<template>
  <div class="page-box">
    <!--    头部-->
    <headerBar />
    <siteNav :selectedIndex="selectedIndex" />
    <!--    头部end-->

    <!---->
    <div class="center-box">
      <div class="qualityControl-box">
        <div class="crumbs">首页 > 中心简介</div>
        <!--中心概况-->
        <div class="generalSituation-box">
          <div class="generalSituation-top">
            <div class="generalSituation-h">上海质控中心</div>
            <div class="generalSituation-p">2024-10-30</div>
          </div>
          <div class="generalSituation-text">
            <p>
              上海市医疗质量控制管理事务中心由上海市医院协会、上海市医学科学技术情报研究所共同组建，在市卫生计生委的指导下具体承担对质控中心的各项管理工作。背景：贯彻落实新医改方案要求，进一步完善质控体系，推动各质控中心更好地工作，为百姓提供优质安全的医疗服务。模式：行政主导，第三方机构监管，市区两级管理，纵向到底横向到边。组建：市政府办公会议确定成立上海市医疗质量控制管理事务中心，为常设机构，事业单位。启动：2012.9.19挂牌，10月正式运作。
            </p>
            <p>职责：</p>
            <p>（一）拟定和落实本市质控中心设置规划、质控中心管理规章制度。</p>
            <p>（二）负责质控中心的日常管理，对质控中心工作进行督促推进和管理考核。</p>
            <p>（三）组织质控中心制定质控计划、质控标准和督查方案，并督促落实。</p>
            <p>（四）汇总各质控中心督查结果，发布质控简讯；根据质控中心上报的督查情况向医疗机构出具整改通知；与本市相关学、协会、卫生监督机构等单位建立信息沟通和联动工作机制。</p>
            <p>（五）推进本市医疗质控管理信息化建设。</p>
            <p>（六）开展医疗质量控制研究工作。</p>
            <p>（七）指导各区县专业质控小组的组建及运行。</p>
            <p>（八）完成市卫生计生委交办的其他工作任务。</p>
          </div>
          <img src="@/assets/images/about.png" />
        </div>
      </div>
    </div>
    <!---->

    <footer-bar></footer-bar>
    <!--    页脚end-->
    <!---->
  </div>
</template>

<script>
import FooterBar from "../../components/base/footerBar";
import headerBar from "@/components/base/headerBar";
import siteNav from "@/components/base/siteNav";

export default {
  name: "index",
  components: { FooterBar, headerBar, siteNav },
  data() {
    return {
      selectedIndex: 8
    }
  },
  methods: {

  },
  mounted() {

  }
}
</script>

<style lang="less" scoped>
.generalSituation-box {
  background: #fff;
  padding: 40px 63px;
  margin-top: 20px;
  width: 100%;
  box-sizing: border-box;

  .generalSituation-top {
    border-bottom: 1px solid rgba(232, 233, 235, 1);
    padding-bottom: 24px;
  }

  .generalSituation-text {
    text-align: left;
    width: 100%;
    box-sizing: border-box;

    p {
      font-size: 15px;
      line-height: 28px;
    }
  }

  img {
    width: 100%;
    vertical-align: bottom;
  }

  .generalSituation-h {
    color: rgba(42, 42, 42, 1);
    font-size: 24px;
    line-height: 32px;
    font-weight: bold;
  }

  .generalSituation-p {
    color: rgba(102, 102, 102, 1);
    font-size: 14px;
    line-height: 14px;
    margin-top: 20px;
  }

  .img {
    width: 980px;
    margin: auto;
    margin-top: 34px;
  }
}

.center-box {
  padding-bottom: 80px;
}
</style>



// WEBPACK FOOTER //
// src/views/CenterProfile/index.vue